import React from 'react';
import { Alert , Button} from 'react-bootstrap'

export default class AlertUpdate extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            show : true
        }
        this.handleCloseAlert = this.handleCloseAlert.bind(this)
    }
    handleCloseAlert() {
        event.preventDefault()
        this.setState({ show: !this.state.show })
    }
    render(){
        return(
            <div className="alert-contact">
                <Alert show={this.state.show} variant="success">
                    <p>
                        Updated successfully!!!
                    </p>
                    <div className="d-flex justify-content-end">
                        <Button className="alert-btn" size="sm"
                            onClick={this.handleCloseAlert}
                        >
                        Close
                        </Button>
                    </div>
                </Alert>
            </div>   
        )
    }
}